import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <footer className="bg-paper border-t border-border px-6 lg:px-8 py-12">
      <div className="max-w-[1280px] mx-auto flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div className="flex items-center gap-2.5">
          <span className="size-8 rounded-full bg-oak flex items-center justify-center">
            <span className="size-3 rounded-full bg-paper" />
          </span>
          <span className="font-display text-xl font-medium tracking-tight">Adminlaget</span>
        </div>
        <nav className="flex items-center gap-6 text-sm text-ink-muted">
          <Link to="/artiklar" className="hover:text-ink transition-colors">Vanliga frågor</Link>
          <Link to="/en/start-a-non-profit-association-in-sweden" hrefLang="en" className="hover:text-ink transition-colors">
            In English
          </Link>
        </nav>
        <p className="text-sm text-ink-muted">
          © {new Date().getFullYear()} Workhome Nordic AB · Bokföring och administration för föreningar
        </p>
      </div>
    </footer>
  );
};